import React from 'react';
import { CapitalProjectSingleNavTab } from './capital-project-single-nav-tab';

export const CapitalProjectWizardNav = ({ step, setStep, capitalProject }) => {
    const toggleClassName = step => {
        setStep(step);
    };

    return (
        <div className="wizard-nav">
            <ul className="nav flex-column sticky-top">
                <CapitalProjectSingleNavTab
                    name="General Info"
                    activeStepEnum={'GENERALINFO'}
                    tabIdName="general"
                    toggleClassName={toggleClassName}
                    step={step}
                    validationErrors={capitalProject.validationErrors}
                />
                <CapitalProjectSingleNavTab
                    name="Cost, Size, and Funding"
                    activeStepEnum={'COSTSIZEFUNDING'}
                    tabIdName="cost-size"
                    toggleClassName={toggleClassName}
                    step={step}
                    validationErrors={capitalProject.validationErrors}
                />
                <CapitalProjectSingleNavTab
                    name="Detail Description"
                    activeStepEnum={'DETAILDESCRIPTION'}
                    tabIdName="description"
                    toggleClassName={toggleClassName}
                    step={step}
                    validationErrors={capitalProject.validationErrors}
                />
                <CapitalProjectSingleNavTab
                    name="Need and Purpose"
                    activeStepEnum={'NEEDSANDPURPOSE'}
                    tabIdName="need"
                    toggleClassName={toggleClassName}
                    step={step}
                    validationErrors={capitalProject.validationErrors}
                />
                <CapitalProjectSingleNavTab
                    name="Other Project Info"
                    activeStepEnum={'OTHERPROJECTINFO'}
                    tabIdName="other"
                    toggleClassName={toggleClassName}
                    step={step}
                    validationErrors={capitalProject.validationErrors}
                />
                <CapitalProjectSingleNavTab
                    name="Space Details"
                    activeStepEnum={'SPACEDETAIL'}
                    tabIdName="space"
                    toggleClassName={toggleClassName}
                    step={step}
                    validationErrors={capitalProject.validationErrors}
                />
                <CapitalProjectSingleNavTab
                    name="Cost Details"
                    activeStepEnum={'COSTDETAIL'}
                    tabIdName="cost"
                    toggleClassName={toggleClassName}
                    step={step}
                    validationErrors={capitalProject.validationErrors}
                />
                <CapitalProjectSingleNavTab
                    name="Annual Cost Details"
                    activeStepEnum={'ANNUALCOSTDETAIL'}
                    tabIdName="annual"
                    toggleClassName={toggleClassName}
                    step={step}
                    validationErrors={capitalProject.validationErrors}
                />
                <CapitalProjectSingleNavTab
                    name="Submit"
                    toggleClassName={toggleClassName}
                    step={step}
                    activeStepEnum={'SUBMIT'}
                    tabIdName="submit"
                    validationErrors={capitalProject.validationErrors}
                />
            </ul>
        </div>
    );
};
